<template>
  <v-card
    class="wz_VcardChat"
    :class="{'bigChat': opened, 'smallChat': !opened}"
    :id="'chat_'+dataWatchVisteur.visiteurID"
  >
    <drag
      class="drag"
      @dragstart="handleDragstart"
      @dragend="handleDragend"
      @dragenter="handleDragenter"
      :transfer-data="{ visiteurID: dataWatchVisteur.visiteurID, placePupitreActif: dataWatchVisteur.placePupitre, menuStelected: dataWatchVisteur.menuSelected, reponseCobrowsing: dataWatchVisteur.reponseCobrowsing }"
    >
      <v-toolbar
        :class="{
          'grey lighten-2': returnFocusSessionId == dataWatchVisteur.visiteurID && $store.state._User.connexionType == 'freshdesk',
          'accent': returnFocusSessionId == dataWatchVisteur.visiteurID && $store.state._User.connexionType != 'freshdesk',
          'grey lighten-4': returnFocusSessionId != dataWatchVisteur.visiteurID,
          'newMessageFocus': returnFocusSessionId == dataWatchVisteur.visiteurID && checkLastMessage,
          'newMessage': returnFocusSessionId != dataWatchVisteur.visiteurID && checkLastMessage,
          'toolbar_ChatBox': true
        }" 
        :dark="returnFocusSessionId == dataWatchVisteur.visiteurID && $store.state._User.connexionType != 'freshdesk'"
        flat
        dense
      >
        <div v-if="visitorLeft == 'yes' && !isMobile" class="clientOffline error">
          {{ $t('offline') }}
        </div>
        <div v-else-if="visitorLeft == 'maybe' && !isMobile" class="clientOffline warning">
          {{ $t('changingPage') }}
        </div>
        <div v-else-if="visitorLeft == 'yes' && isMobile" class="clientOffline error">
        </div>
        <div v-else-if="visitorLeft == 'maybe' && isMobile" class="clientOffline warning">
        </div>
        <v-flex xs1 ml-1 @click.prevent.stop>
          <wz-avatar
            v-if="dataWatchVisteur.network == 'facebook'"
            :src="dataWatchVisteur.profile_pic"
            :username="nameVisiteur"
            size="38px"
          ></wz-avatar>
          <wz-avatar
            v-else-if="dataWatchVisteur.network == 'whatsapp'"
            :src="dataWatchVisteur.profile_pic"
            :username="nameVisiteur"
            size="38px"
          ></wz-avatar>
          <wz-avatar
            v-else-if="dataWatchVisteur.network == 'moon'"
            :username="'#' + nameVisiteur"
            size="35px"
          ></wz-avatar>
          <wz-avatar
            v-else
            :username="'#' + nameVisiteur"
            size="35px"
          ></wz-avatar>
        
        </v-flex>

        <v-flex ellipsis ml-1 >
          <v-toolbar-title
            class="ws_TitreChat"
          >
          {{nameVisiteur}}
          </v-toolbar-title>
          <v-toolbar-title class="ws_sousTitreChat">{{lastMessage}}</v-toolbar-title>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          v-if="$vuetify.breakpoint.xsOnly"
          icon
          small
          @click="afficheInfosVisiteur()"
        >
          <v-icon large>info</v-icon>
        </v-btn>
        <v-btn
          v-if="!$vuetify.breakpoint.xsOnly"
          v-show="opened"
          icon
          small
          @click="toggleBigChat()"
        >
          <v-icon class="rotate90Icone">{{ fullWidth ? 'unfold_less' : 'unfold_more' }}</v-icon>
        </v-btn>
        <v-btn
          v-if="!$vuetify.breakpoint.xsOnly"
          icon
          small
          @click="toggleChat()"
        >
          <v-icon>{{ opened ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
        </v-btn>
        <v-btn icon small @click="fermeChat()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
    </drag>

    <v-container v-if="loadingChat" fill-height>
      <v-layout flex align-center justify-center>
        <v-card flat>
          <v-card-text >
            <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
    
    <div
      :class="{
        'chatSession': true,
        'visioConfON': dataVisio.confURL || dataVisioVente.confName,
        'visioConfOFF': !dataVisio.confURL && !dataVisioVente.confName,
      }"
     :id="'chatSession_' + datasVisiteur.visiteurID"

    >
      <!-- <div class="presenceVisiteur cache" v-if="!dataWatchVisteur.status || dataWatchVisteur.status == 'offline'">
        <div class="grey lighten-4 elemCenter">
          Le visiteur est actuellement offline <br />
          <v-btn secondary dark @click="fermeChat()">Fermer la discussion</v-btn>
        </div>
      </div> -->

    <!-- visioconf -->
      <div
        :class="{
          'inactif': !dataVisio.confURL
        }"
        id="watchBox_visioconf"
        v-if="dataVisio.confURL"
      >
        <iframe
          id="apzExtension"
          allow='camera *;microphone *;self;display-capture'
          :src="dataVisio.confURL"
          frameborder="0"
          @error="handleVisioError"
          @load="handleVisioLoaded"
        ></iframe>
      </div>

    <!-- conteneur chat -->
      <div 
        :class="{
          'WatchBox-contentChat': true,
          'retract': !chatExpand,
          'expand': chatExpand,
          'fullWidthChat': fullWidth,
          'vb': true
        }"
        :id="id_conversation"
        v-bar
      >
        <div

          class="WatchBox-conversation"
          ref="contentChat"
          @scroll="handleScroll"
          >

          <v-hover
            v-for="(dataMessage, index) in datasVisiteur.histoChat"
            :class="{
              'bulle_BO': !dataMessage.isTyping && !dataMessage.dateMessage && !dataMessage.marqueurMessageNonLu,
              'bulle-message-non-lu_BO': !dataMessage.isTyping && !dataMessage.dateMessage && dataMessage.marqueurMessageNonLu,
              'bulle-date_BO': dataMessage.dateMessage,
              'green': dataMessage.type === '18'
            }"
            :style="'z-index:' + (dataMessage.indexMessage+1) + ';'"
            :key="index"
          >
          
            <!-- Pour toutes les bulles visiteur et agents (sauf le isTyping et les dates) -->
            <!-- et les bulles chat arrivées apres le bloquage du scroll -->
            <div slot-scope="{ hover }">
              
              <div
                v-if="!dataMessage.isTyping && !dataMessage.dateMessage && !dataMessage.marqueurMessageNonLu"

                :class="'bulle_' + dataMessage.auteur + '_BO'"
              >
              <!-- ajoute l'avatar de l'agent ou du bot -->
              <wz-avatar
                v-if="dataMessage.auteur == 'Agent' || dataMessage.auteur == 'Bot'"
                :username="dataMessage.nameAuteur"
                class="avatarChatBo"
                :src="`${domaine}/public/media/user/small/${dataMessage.agentId}_avatar.jpg`"
                size="35px"
              ></wz-avatar>
                <!-- cloture de chat -->
                <v-layout v-if="index > 1 &&
                                datasVisiteur.histoChat[index - 1].chatSession &&
                                datasVisiteur.histoChat[index].chatSession &&
                                datasVisiteur.histoChat[index].chatSession != datasVisiteur.histoChat[index - 1].chatSession">
                  <v-flex xs12 class="text-xs-center">
                    <v-chip
                      label
                      disabled
                      color="secondary"
                      text-color="white"
                    >
                      {{ $t('closing') }}
                      <v-icon right dark>offline_pin</v-icon>
                    </v-chip>
                  </v-flex>
                </v-layout>
                <div :class="'message' + dataMessage.auteur + '_BO'"
                  @click="dataMessage.type == 18 && switchToScreenSharing()"
                >
                  <!-- Auteur du message -->
                  <div
                    v-if="dataMessage.auteur == 'Visiteur' && isMobile "
                    :class="'nom_' + dataMessage.auteur + '_BO'"
                  >
                    {{ dataMessage.type == 2 ? '(' + $t('msgAuto') + ')': '' }}
                  </div>
                  <div
                    v-else
                    :class="'nom_' + dataMessage.auteur + '_BO'"
                  >
                    {{ 
                      nameAuteur[index]
                        ? dataMessage.nameAuteur
                        : dataMessage.visitorId == datasVisiteur.visiteurID
                          ? nameVisiteur
                          : dataMessage.visitorId 
                    }}
                    {{ dataMessage.type == 2 ? '(' + $t('msgAuto') + ')': '' }}
                  </div>
                  
                  <!-- Heure du message -->
                  <div :data-timestamp="dataMessage.timestamp" :class="'timestamp_' + dataMessage.auteur + '_BO'">
                    {{ dateHeure[index] }}
                  </div>
                  <!-- Contenu du message -->
                  <div v-if="dataMessage.message && dataMessage.message != 'undefined'" :class="'hms message_' + dataMessage.auteur">
                    <!-- Si trouve une url dans le message -->
                    <!--<a v-if="findUrls[index].length" :href="`${findUrls[index]}`" target="_blank" v-text="dataMessage.message"></a>-->
                    <div v-if="findUrls[index].length" v-html="findUrls[index]" class="txtChat"></div>
                    <!-- Sinon message classique -->
                    <div v-else v-text="dataMessage.message" class="txtChat"></div>
                  </div>
                  <!-- Pièces jointes -->
                  <div v-if="dataMessage.attachments && (dataMessage.attachments != 'null' && dataMessage.attachments != 'undefined')" >  

                  <!-- image facebook temporaire-->
                    <a v-if="dataMessage.attachments.split(':')[0] == 'https' && dataMessage.attachments.split('.')[1] == 'fbsbx'" :href="dataMessage.attachments" target="_blank" style="text-decoration: none;" >
                      <div v-if="dataMessage.attachments.split('.')[1] == 'pdf' || dataMessage.attachments.split('.')[1] == 'doc' || dataMessage.attachments.split('.')[1] == 'zip'">
                        <v-icon
                          large
                          class="grey--text"
                        >attachment
                        </v-icon>{{dataMessage.attachments.split('.')[1]}}
                      </div>
                      <div v-else>
                        <img
                          :src="dataMessage.attachments"
                          title=""
                          rel=""
                          :alt="dataMessage.attachments.split('.')[1]"
                          class="attachmentsMedia"
                          @load="remonteChat()"
                        />
                      </div>
                    </a>

                  <!-- image facebook -->
                    <a v-else-if="dataMessage.attachments.split(':')[0] == 'https' && dataMessage.attachments.split('.')[2] == 'fbcdn'" :href="dataMessage.attachments" target="_blank" style="text-decoration: none;" >
                      <div>
                        <img
                          :src="dataMessage.attachments"
                          title=""
                          rel=""
                          :alt="dataMessage.attachments.split('.')[4]"
                          class="attachmentsMedia"
                          @load="remonteChat()"
                        />
                      </div>
                    </a>

                  <!-- image en dur chez watcheezy -->
                    <a v-else-if="dataMessage.attachments.split(':')[0] == 'https' && dataMessage.attachments.split('.')[1] == 'watcheezy'" :href="dataMessage.attachments" target="_blank" style="text-decoration: none;" >
                      <div>
                        <img
                          :src="dataMessage.attachments"
                          title=""
                          rel=""
                          :alt="dataMessage.attachments.split('.')[3]"
                          class="attachmentsMedia"
                          @load="remonteChat()"
                        />
                      </div>
                    </a>

                    <!-- image en dur chez targetfirst -->
                    <a v-else-if="dataMessage.attachments.split(':')[0] == 'https' && dataMessage.attachments.split('.')[1] == 'targetfirst'" :href="dataMessage.attachments" target="_blank" style="text-decoration: none;" >
                      <div>
                        <img
                          :src="dataMessage.attachments"
                          title=""
                          rel=""
                          :alt="dataMessage.attachments.split('.')[3]"
                          class="attachmentsMedia"
                          @load="remonteChat()"
                        />
                      </div>
                    </a>

                    <!-- image en dur chez whatsapp -->
                    <a v-else-if="dataMessage.attachments.split(':')[0] == 'https'" :href="dataMessage.attachments" target="_blank" style="text-decoration: none;" >
                      <div>
                        <img
                          :src="dataMessage.attachments"
                          title=""
                          rel=""
                          :alt="dataMessage.attachments.split('.')[3]"
                          class="attachmentsMedia"
                          @load="remonteChat()"
                        />
                      </div>
                    </a>

                    <!-- image sur S3 -->
                    <a v-else :href="'https://box-targetfirst.s3.fr-par.scw.cloud/' + dataMessage.attachments" target="_blank" style="text-decoration: none;" >
                      <!-- <div v-if="checkFile('dataMessage.attachments')"> -->
                        <div v-if="dataMessage.attachments.split('.')[1] == 'pdf' || dataMessage.attachments.split('.')[1] == 'doc' || dataMessage.attachments.split('.')[1] == 'zip'">
                          <v-icon
                            large
                            class="grey--text"
                          >attachment
                          </v-icon>{{dataMessage.attachments.split('.')[1]}}
                        </div>
                        <div v-else>
                          <img
                            :src="'https://box-targetfirst.s3.fr-par.scw.cloud/' + dataMessage.attachments"
                            title=""
                            rel=""
                            :alt="dataMessage.attachments.split('.')[1]"
                            class="attachmentsMedia"
                            @error="imageLoadError"
                            @load="remonteChat()"
                          />
                        </div>
                      <!-- </div> -->
                    </a>

                  </div>
                  <v-btn
                    icon
                    small
                    @click="copyMessage(dataMessage.message)"
                    v-show="hover"
                    style="margin:0; position: absolute; top: 16px; right: 6px;"
                    :title="$t('copyText')"
                  >
                    <v-icon small>content_copy</v-icon>
                  </v-btn>
                  <div v-if="dataMessage.status == 'delivery'" class="">({{ $t('messageSent')}})</div>
                  <div v-else-if="dataMessage.status == 'read'" class="">({{ $t('messageRead')}})</div>
                </div>
                
              </div>

              <!-- Nouveau message lors d'un scroll -->
              <v-btn
                v-else-if="!dataMessage.isTyping && !dataMessage.dateMessage && dataMessage.marqueurMessageNonLu"

                class="alert-message-non-lu primary"
                block
                @click="showUnreadMessages()"
              >
                <div class="message-non-lu WZ-MessageChat white--text">
                  <v-icon medium dark>forum</v-icon>
                  {{ $tc('unreadMessages', nbMessageNonLu, {count: nbMessageNonLu}) }}
                </div>
              </v-btn>

              <!-- Pour les bulles date uniquement -->
              <div
                v-else-if="!dataMessage.isTyping"

                class="bulle_date_BO"
              >
                <div class="dates-messages_BO WZ-MessageChat">{{dataMessage.timeStamp}}</div>
              </div>
            </div>
          </v-hover>
          <!-- Pour les bulles isTyping uniquement -->
          <div
            v-for="(dataMessage, index) in dataWatchVisteur.histoChat"
            :key="dataMessage.timestamp ? dataMessage.timestamp + '_' + index : 'message_' + index"
          >
            <div
              v-if="dataMessage.isTyping"
              :class="'isTyping_' + dataMessage.auteur + '_BO'"
            >
              <div class='isTyping_nom_BO'>
                <div v-if="dataMessage.auteur == 'Visiteur' && isMobile" class='wz_nom_visiteur'></div>
                <div v-else class='wz_nom_visiteur'>{{dataMessage.nameAuteur}}</div>
              </div>
              <div class='isTyping_message'>
                <div class='WatchBox-istyping_BO'>
                  <div class='bounce1'></div>
                  <div class='bounce2'></div>
                  <div class='bounce3'></div>
                </div>
                <div class='txt-superIstyping'>{{dataMessage.message}}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- AUTOCOMPLÉTION -->
        <transition name="slide-y-transition" mode="in-out">
          <div v-show="filteredSentences.length && showFilteredSentences" style="z-index: 99; position: relative;">
            <v-card height="200" v-bar>
              <v-list two-line dense subheader>
                <v-layout>
                  <v-flex xs10>
                    <v-subheader>{{ $tc('sentences', filteredSentences.length, {count: filteredSentences.length}) }}</v-subheader>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    @click="showFilteredSentences = false"
                  >
                    <v-icon color="secondary">close</v-icon>
                  </v-btn>
                </v-layout>
                <v-list-tile 
                  v-for="phrase in filteredSentences"
                  :key="phrase.id"
                  @click="(status === 'offline' && $route.fullPath !== '/trafic/attente') ? ';' : $emit('update:msg', phrase.title); showFilteredSentences = false"
                >
                  <v-list-tile-content>
                    {{ phrase.title | truncate(80) }}
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      @click.stop="(status === 'offline' && $route.fullPath !== '/trafic/attente') ? ';' : sendMessage({'message':phrase.title})"
                      color="secondary--text"
                      icon
                      small
                    >
                      <v-icon>send</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card>
          </div>
        </transition>

        <!-- ZONE DE SAISIE pour moon -->
        <div
          class="WatchBox-MessageWrapper"
          v-if=" $route.name != 'monitoring' || ($route.name === 'monitoring' && brideMenu('trafic_monitoring_chat_superviseur') === '1')"
        >
          <v-container grid-list-xs class="conteneur-WatchBox-MessageWrapper">
            <v-layout flex-child wrap>
              <v-flex xs12 pa-0>
                <!-- ENVOYER PIECE JOINTE ET/OU MESSAGE-->
                <v-textarea
                  id="tf_txtareaChat"
                  v-if="datasVisiteur"
                  ref="inputChat"
                  v-model="msgInput"
                  @keyup="e => keyup(e)"
                  @keydown="e => keydown(e)"
                  @click="clickstartTimerExpand()"
                  :loading="loading"
                  rows="2"
                  auto-grow
                  full-width
                  append-icon="send"
                  @click:append="clickSendMessage()"
                  hide-details
                  flat
                  box
                  :placeholder="placeholder"
                >
                </v-textarea>
                <!-- :rules="[(v) => v.length <= maxLength || `Max ${maxLength} characters`]" -->
              </v-flex>
              
            </v-layout>
            <v-layout class="options-WatchBox-MessageWrapper" flex-child wrap>
              <v-flex
                xs1
                mr-2
                text-xs-right
                class='WatchBox-Toolbar-Icone'
              >
                <!-- EMOJI LISTE-->
                <wz-emoji-picker
                  v-if="datasVisiteur"
                  @addEmoji="addEmoji"
                ></wz-emoji-picker>
              </v-flex>
              <v-flex
                mr-2
                xs1
                text-xs-right
                class='WatchBox-Toolbar-Icone'
              >
                <!-- PIECES JOINTES-->
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      class="tf-icone-toolbar-chat"
                      :flat="!dragEnter"
                      icon
                      color="primary"
                      @click="addFileDropzone()"
                    >
                      <v-icon>attachment</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('addPJ')}}</span>
                </v-tooltip>
              </v-flex>
              <!--
              <v-flex xs1 pa-0>
                <v-btn flat icon color="primary" @click="clickSendMessage()">
                  <v-icon>send</v-icon>
                </v-btn>
              </v-flex>
              -->
            </v-layout>
          </v-container>
        </div>
      </div>

      <vue-dropzone
          v-if="dragEnter && (entLevel === '5' || entLevel === '6' || entLevel === '7') "
          ref="theDropZone"
          id="dropzone_BO"
          :options="dropzoneOptions"
          @vdropzone-file-added="fileAdded"
          @vdropzone-sending="sending"
          @vdropzone-success="success"
          @vdropzone-error="error"
          @vdropzone-removed-file="removedFile"
          @vdropzone-drop="vddrop"
          @vdropzone-drag-start="vdstart"
          @vdropzone-drag-end="vdend"
          @vdropzone-drag-enter="vdenter"
          @vdropzone-drag-over="vdover"
          @vdropzone-drag-leave="vdleave"
          class="wz_dropzone actifDropZone"
      >
      </vue-dropzone>

<!-- visioVente -->
      <div 
       v-if="activeVisiovente"
        :div="nameDivVisioStreams"
        class="tf_visioVente"
      >
        <div class="tf_menuVisio">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                color="grey"
                text-color="white"
                class="visioVente_num_visiteur"
              >
                <v-avatar>
                  <v-icon class="primary">account_circle</v-icon>
                </v-avatar>
                {{numContacts}}
              </v-chip>
            </template>
            <span>{{ $t('Nombre d\'intenautes connectés')}}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                dark
                small
                color="error"
                class="visioVente_stop"
                @click="stopVisioVente()"
              >
                <v-icon dark>call_end</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Arrêter la Diffusion')}}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                dark
                small
                :color="!muteMic ? 'success' : 'grey'"
                class="visioVente_muteMic"
                @click="toggleMic()"
              >
                <v-icon dark>mic</v-icon>
              </v-btn>
            </template>
            <span>{{textMuteMic}}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                dark
                small
                :color="!muteCam ? 'success' : 'grey'"
                class="visioVente_muteCam"
                @click="toggleCam()"
              >
                <v-icon dark>videocam</v-icon>
              </v-btn>
            </template>
            <span>{{textMuteCam}}</span>
          </v-tooltip>
        </div>
        <div class="actionUnzoomVideo" @click="toggleStream()"></div>
        <div :id="nameDivLocalStream"
            :class="{
              'tf_localVideo': true,
              'zoomStream': zoomStream
            }" 
        >
        </div>
        
        <div :id="nameDivRemoteStream"
          :class="{
            'tf_remoteVideo': true,
            'zoomStream': !zoomStream
          }"
        >
        </div>
      </div>
<!-- fin visioVente -->

    </div>

    <!-- dialog close chat visiteur -->
    <wz-dialog-close-chat
      @fermeDialogCloseChat="fermeDialogCloseChat"
      :datasVisiteur="datasVisiteur"
      :dialogCloseChat="dialogCloseChat"
    >
    </wz-dialog-close-chat>

  </v-card>
</template>

<script>
// Modules
import moment from 'moment'
import axios from 'axios'
import _ from 'lodash'
import md5 from 'js-md5'
import { Drag } from 'vue-drag-drop'
import extractDomain from 'extract-domain'
// Socket
import _watcheebox from '../watcheebox/watcheebox.js'
// Store
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
// Constantes
import { DOMAINE, PUBLIC, AWSS3_PUBLIC } from '../../constants'
// Styles
import '../../assets/css/watcheeBoxStyle.css'
// Composant
import WzEmojiPicker from './WzEmojiPicker'

export default {
  components: {
    Drag,
    WzEmojiPicker
  },
  data () {
    return {
      domaine: DOMAINE,
      signer: {},
      fileName: '',
      timeTimer: 3000,
      maxLength: 256,
      myTimer: '',
      agentsChecked: [],
      chatActivity: true, // activité agent sur ce chat
      activeVisiovente: false,
      nameDivVisioStreams: this.$route.fullPath === '/trafic/visitors' ? 'tf_visioVente_0' : 'tf_visioVente_' + this.datasVisiteur.placePupitre,
      nameDivLocalStream: this.$route.fullPath === '/trafic/visitors' ? 'tf_localVideo_0' : 'tf_localVideo_' + this.datasVisiteur.placePupitre,
      nameDivRemoteStream: this.$route.fullPath === '/trafic/visitors' ? 'tf_remoteVideo_0' : 'tf_remoteVideo_' + this.datasVisiteur.placePupitre,
      modeleMessage: [
        'Your login code for {{1}} is {{2}}',
        'Your {{1}} order of {{2}} has shipped and should be delivered on {{3}}. Details : {{4}}',
        'Your {{1}} appointment is coming up on {{2}}'
      ],
      dropzoneOptions: {
        url: AWSS3_PUBLIC,
        previewTemplate: this.templateDropZone(),
        addRemoveLinks: true,
        addSendLinks: true,
        autoProcessQueue: false,
        maxFiles: 1,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        acceptedMimeTypes: 'image/*,application/pdf,.zip,.doc',
        maxFilesize: 4, // in mb
        clickable: false,
        maxThumbnailFilesize: 4, // 4MB
        // traductions
        dictDefaultMessage: this.$t('dropFileHere'),
        dictFallbackMessage: this.$t('dropNoBrowser'),
        dictFallbackText: this.$t('dropForm'),
        dictFileTooBig: this.$t('dropMore') + ' {{filesize}}Mo ' + this.$t('dropMaxSize') + ' {{maxFilesize}}Mo',
        dictInvalidFileType: this.$t('dopNoFile'),
        dictResponseError: this.$t('dropError') + ' {{statusCode}}',
        dictCancelUpload: this.$t('dropAnnul'),
        dictCancelUploadConfirmation: this.$t('dropConfirmCancel'),
        dictRemoveFile: this.$t('dropSupFile'),
        dictMaxFilesExceeded: this.$t('dropFailMore')
      },
      dDrop: false,
      dStarted: false,
      dEnded: false,
      dEntered: false,
      dOver: false,
      dLeave: false,
      dragEnter: false,
      fileAdd: false,
      newBtnSend: '',

      loading: false,
      msgInput: '',
      widthDate: 100, // largeur de la fenetre de chat
      starDate: '', // date du premiere mesasge du chat
      dialogCloseChat: false,
      dialogBannChat: false,
      isTyping: false,
      chatExpand: false,
      typingTimer: null,
      formulaireSatisfaction: false,
      clotureChat: false,
      positionNodeChat: '', // position de la div chat dans le DOM (this.$el.childNodes[2].lastChild)
      selectedAgent: {
        id: '',
        name: '',
        status: ''
      },
      selectedVisiteur: '',
      dialogTransfereChat: false,
      lastMessage: '',
      conteneurChat: null,
      /**
       * Indique si la fenêtre de chat est déployée
       * @type {Boolean}
       */
      opened: true,
      fullWidth: false,
      checkForMotif: false,
      id_conversation: '',
      dataWatchVisteur: {}, // stocke les data visiteurs meme si 'dataVisiteur' est undefined
      doOnce: 0,
      /* --- pour le scroll du chat --- */
      scrollPosition: 0,
      stopScrollAuto: false,
      marqueurChat: false,
      visitorLeft: 'yes',
      showFilteredSentences: false,
      showPhrases: false,
      overMenu: false,
      myTimerExpand: null,
      myTimerIsTyping: null,
      pauseExpandChat: 15000,
      dragChatStatus: false,
      numContacts: 0,
      zoomStream: true,
      loadingSub: true
    }
  },

  props: [
    'datasVisiteur',
    'loadingChat',
    'msg'
  ],

  methods: {
    ...mapMutations('_StoreWatcheeBox', [
      'SET_VISITEURS',
      'SET_VISITEURS_OPENED_HISTOCHAT',
      'SET_CONTACT_OPENED_HISTOCHAT',
      'CHANGE_DRAG_CHAT',
      'SET_STATUS_TIMERINACTIFAGENT'
    ]),
    ...mapMutations('_User', [
      'SET_DEL_MESSAGE_ATTENTE'
    ]),
    ...mapActions('_StoreWatcheeBox', [
      'ACTION_CLOSE_CHAT',
      'ACTION_CLOSE_MESSAGING',
      'CHECK_DISPO_AGENT'
    ]),
    switchToScreenSharing () {
      this.$emit('openScreensharing', this.dataWatchVisteur.visiteurID)
    },
    handleVisioError (event) {
      console.warn('handleError', event)
    },
    handleVisioLoaded (event) {
      console.warn('handleLoaded', event)
    },

    handleDragstart () {
      console.log('drag chat', this.dragChatStatus)
      this.CHANGE_DRAG_CHAT(true)
      this.dragChatStatus = true
    },

    handleDragend () {
      console.log('stop drag chat', this.dragChatStatus)
      this.CHANGE_DRAG_CHAT(false)
      this.dragChatStatus = false
    },
    handleDragenter () {
      console.log('drag enter drop', this.dragChatStatus)
    },

    // ----------------------------------------------------------------------------
    // Cette fonction remonte le chat afin de voir le dernier message ecrit par l'agent
    // ----------------------------------------------------------------------------
    remonteChat () {
      if (this.$refs.contentChat) {
        // uniquement si scroll autorisé
        if (!this.stopScrollAuto) {
          this.$refs.contentChat.scrollTo(
            0,
            this.$refs.contentChat.scrollHeight
          )
        }
      }
    },

    // ----------------------------------------------------------------------------
    // action sur les touches du clavier
    // ----------------------------------------------------------------------------
    keyup (e) {
      // présence activité de l'agent
      this.keyDownMonitor()
      // touche entrée
      if (e.keyCode === 13 && !e.shiftKey) {
        // console.log('entrée : ', e)
        let msgToSend = this.msgInput
        if (msgToSend.indexOf('\n') !== -1) {
          msgToSend = msgToSend.replaceAll('\n', '<br>')
        }
        console.log('this.msgInput : ', msgToSend)
        this.dragEnter ? this.uploadFiles({ message: msgToSend }) : this.sendMessage({ message: msgToSend })
      }
    },

    // ----------------------------------------------------------------------------
    // action sur la touche entrer du clavier, pour le pas afficher <br> dans le chat
    // ----------------------------------------------------------------------------
    keydown (e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault()
      }
    },

    // ----------------------------------------------------------------------------
    // Ajoute l'emoji dans le textarea
    // ----------------------------------------------------------------------------
    addEmoji (emoji) {
      // console.log('addEmoji', emoji)
      this.msgInput = this.msgInput + emoji
    },

    // ----------------------------------------------------------------------------
    // Check si les images sur S3 existe toujours
    // ----------------------------------------------------------------------------
    // checkFile (file) {
    //   var monImage = new Image()
    //   // quand le chargement est terminé
    //   monImage.onload = function () {
    //     return true
    //   }
    // },
    // ----------------------------------------------------------------------------
    // Stop la visioVnete
    // ----------------------------------------------------------------------------
    stopVisioVente () {
      let dataChange = {
        name: 'leaveConf',
        value: true,
        placePupitreVisio: this.datasVisiteur.placePupitre,
        visiteurID: this.datasVisiteur.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    },
    // ----------------------------------------------------------------------------
    // active/desactive le micro
    // ----------------------------------------------------------------------------
    toggleMic () {
      let dataChange = {
        name: 'muteMic',
        value: !this.muteMic,
        placePupitreVisio: this.datasVisiteur.placePupitre,
        visiteurID: this.datasVisiteur.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    },
    // ----------------------------------------------------------------------------
    // active/desactive la camera
    // ----------------------------------------------------------------------------
    toggleCam () {
      let dataChange = {
        name: 'muteCam',
        value: !this.muteCam,
        placePupitreVisio: this.datasVisiteur.placePupitre,
        visiteurID: this.datasVisiteur.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    },
    // ----------------------------------------------------------------------------
    // inverse les vidéos
    // ----------------------------------------------------------------------------
    toggleStream () {
      let dataChange = {
        name: 'toggleStream',
        value: !this.toggleVideoStream,
        placePupitreVisio: this.datasVisiteur.placePupitre,
        visiteurID: this.datasVisiteur.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    },

    imageLoadError () {},

    templateDropZone () {
      return `
          <div>
            <div class="dz-preview dz-image-preview">
              <div class="dz-image">
                <img data-dz-thumbnail>
              </div>
              <div class="dz-details">
                <div class="dz-size"><span data-dz-size></span></div>
                <div class="dz-filename"><span data-dz-name></span></div>
              </div>
              <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
              <div class="dz-error-message"><span data-dz-errormessage></span></div>
              <div class="dz-success-mark"><i class="fa fa-check"></i></div>
              <div class="dz-error-mark"><i class="fa fa-close"></i></div>
              <div class="dz-btSend">
                <button type="button" id="buttonSendImg" class="btn btn--floating btn--large theme--dark primary" data-ripple="true" style="position: relative;">
                  <div class="btn__content">
                    <i aria-hidden="true" class="material-icons icon theme--dark">send</i>
                  </div>
                </button>
              </div>
            </div>
          </div>
        `
    },

    // ----------------------------------------------------------------------------
    // Dropzone events
    // ----------------------------------------------------------------------------
    sending (file, xhr, formData) {
      // recupere juste l'extention du fichier
      var indicSlash = file.name.lastIndexOf("'")
      var tabDecomp = file.name.substring(indicSlash + 1).split('.')
      var extension = tabDecomp[tabDecomp.length - 1]
      this.fileName =
        md5(Date.now() + '_' + file.name.trim().replace(' ', '_')) +
        '.' +
        extension

      formData.append('key', this.fileName)
      formData.append('acl', 'public-read-write')
      formData.append('success_action_status', '201')
      formData.append('Content-Type', '')
      formData.append('X-amz-Algorithm', 'AWS4-HMAC-SHA256')
      formData.append(
        'X-amz-Credential',
        this.signer.signature['X-amz-credential']
      )
      formData.append('X-amz-Date', this.signer.signature['X-amz-date'])
      formData.append('Policy', this.signer.signature['policy'])
      formData.append(
        'X-amz-Signature',
        this.signer.signature['X-amz-signature']
      )
    },
    success (file, response) {
      let formData = new window.FormData()
      formData.append('fileName', this.fileName)
      // this.axios.post('post/attachment_in_chat.php', formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      this.sendMessage({ message: this.msgInput, attachments: this.fileName })
      this.loading = false
      this.dragEnter = false
      this.$store.dispatch('_Notifier/NEW_NOTIF', {
        message: this.$t('uploadSuccess'),
        context: 'success'
      })
      // efface l'ecouteur sur le nouveau bouton d'envois d'amge
      this.newBtnSend.removeEventListener('click', this.uploadFiles, false)
    },
    error (file) {
      this.loading = false
      // this.dragEnter = false
      // efface l'ecouteur sur le nouveau bouton d'envois d'amge
      this.newBtnSend.removeEventListener('click', this.uploadFiles, false)
    },
    removedFile (file, error, xhr) {
      this.dragEnter = false
      // this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('uploadError'), context: 'error' })
      // efface l'ecouteur sur le nouveau bouton d'envois d'amge
      this.newBtnSend.removeEventListener('click', this.uploadFiles, false)
    },
    uploadFiles () {
      console.log('uploadFiles')
      this.loading = true
      let url =
        // process.env.NODE_ENV === 'development'
        //   ? `${DOMAINE}/dev/ajax-webpack/utils/aws-s3-url-signer-php-master/`
        //   : `${DOMAINE}/ajax-webpack/utils/aws-s3-url-signer-php-master/`
        process.env.NODE_ENV === 'development'
          ? `${PUBLIC}/api/utils/scaleway-s3-url-signer-php-master/`
          : `${PUBLIC}/api/utils/scaleway-s3-url-signer-php-master/`
      axios
        .get(url)
        .then(res => {
          this.signer = res.data
          this.$refs.theDropZone.processQueue()
        })
        .catch()
    },
    vdenter (e) {
      console.log('vdenter', e)
      this.dEntered = true
    },
    vdover (e) {
      console.log('vdover', e.srcElement.ownerDocument.activeElement.innerText)
      this.dOver = true
    },
    vddrop (event) {
      // console.log('vddrop', event.srcElement.ownerDocument.activeElement.innerText)
      // test quant on drop si c'est bien un fichier
      // avec un delai pour etre sur que l'evenement fileadded est bien executé
      setTimeout(this.testFileAdded, 1000)
      // this.testFileAdded()
      this.dDrop = true
    },
    vdstart () {
      console.log('vdstart')
      this.dStarted = true
    },
    vdend () {
      console.log('vdend')
      this.dEnded = true
    },
    vdleave () {
      console.log('vdleave')
      // marche uniquement si c'est pas un chat qui est drag
      if (!this.dragChatStatus) {
        this.dLeave = true
        this.dragEnter = false
      }
    },
    fileAdded (event) {
      console.log('fileAdded', this.dragChatStatus)
      // marche uniquement si c'est pas un chat qui est drag
      if (!this.dragChatStatus) {
        this.fileAdd = true
        // ajout un ecouteur sur le nouveau bouton d'envois d'image
        this.newBtnSend = document.getElementById('buttonSendImg')
        this.newBtnSend.addEventListener('click', this.uploadFiles, false)
      }
    },
    testFileAdded () {
      console.log('testFileAdded', this.fileAdd)
      if (this.fileAdd) {
        // c'est bien un fichier alors on réinitialise la variable
        this.fileAdd = false
      } else {
        // c'est pas un fichier alors on efface la dropzone
        this.dragEnter = false
      }
    },
    addFileDropzone () {
      console.log('affiche dropzone', this.dragChat)
      if (this.dragEnter) {
        this.dragEnter = false
      } else {
        this.dragEnter = true
      }
    },

    // ----------------------------------------------------------------------------
    // Check si l'utilisateur à touché au scroll du chat
    // si oui on bloque le le scroll automatique du chat
    // pour eviter qu'il remonte tout seul
    // ----------------------------------------------------------------------------
    handleScroll (e) {
      // console.log('scroll du chat ', e)
      // visible height + pixel scrolled = total height
      let element = e.srcElement || e.target
      if (element.offsetHeight + element.scrollTop === element.scrollHeight) {
        // je suis bien en bas de scroll le peut réactivé le scroll automatique
        this.stopScrollAuto = false
        this.marqueurChat = false
        // marque toutes les bulles de chat non lu comme lu
        _.forEach(this.dataWatchVisteur.histoChat, (chat, key) => {
          if (!chat.lu) {
            // marque dans l'histoChat tous les messages sont lu par l'agent
            this.$store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_LU', {
              timestamp: chat.timestamp,
              visitorId: chat.visitorId
            })
          }
        })
        // efface les marqueurs de message non lu
        this.$store.commit('_StoreWatcheeBox/SOCKET_REMOVE_CHAT_NON_LU', {
          visitorId: this.dataWatchVisteur.visiteurID
        })
      } else if (element.scrollHeight - (element.offsetHeight + element.scrollTop) > 50) {
        // pour etendre le chat si en visio uniquement si le scroll bouge
        if (this.dataVisio) {
          if (!this.chatExpand) {
            // console.log('start timer expand')
            this.startTimerExpand()
          }
        }
        // j'ai touché au scroll il est descendu de plus de 50 pixel, je bloque la fonction de scroll automatique
        this.stopScrollAuto = true
      }
    },

    // ----------------------------------------------------------------------------
    // Detection si le chat est etendu uniquement en cas de visio
    // ----------------------------------------------------------------------------
    clickstartTimerExpand () {
      // console.log('click champ')
      this.startTimerExpand()
    },
    startTimerExpand () {
      if (this.dataVisio) {
        // console.log('startTimerExpand', this.chatExpand)
        clearTimeout(this.myTimerExpand)
        this.chatExpand = true
        // setTimeout(this.stopTimerExpand, 5000)
        this.myTimerExpand = setTimeout(() => {
          this.stopTimerExpand()
        }, this.pauseExpandChat)
      }
    },
    // ----------------------------------------------------------------------------
    // arrete le time expand du chat
    // ----------------------------------------------------------------------------
    stopTimerExpand () {
      // if (this.dataVisio) {
      clearTimeout(this.myTimerExpand)
      this.chatExpand = false
      // }
    },
    // ----------------------------------------------------------------------------
    // Detection des touche du clavier down
    // ----------------------------------------------------------------------------
    keyDownMonitor () {
      // console.log('keyDownMonitor', this.isTyping)
      this.startTimerExpand() // lance le timer extention chat pour la visio uniquement
      clearTimeout(this.myTimerIsTyping)
      // if (!this.isTyping) {
      this.startTyping()
      // this.isTyping = true
      this.myTimerIsTyping = setTimeout(() => {
        this.stopTimerTyping()
      }, 5000)
      // this.myTimerIsTyping = setTimeout(this.stopTimerTyping, 5000)
      // }
    },

    // ----------------------------------------------------------------------------
    // arrete le istyping
    // ----------------------------------------------------------------------------
    stopTimerTyping () {
      // console.log('stopTimerTyping ', this.isTyping)
      // if (this.isTyping) {
      clearTimeout(this.myTimerIsTyping)
      this.stopTyping()
      // this.isTyping = false
      // }
    },

    // ----------------------------------------------------------------------------
    // Demarrage du istyping
    // ----------------------------------------------------------------------------
    startTyping () {
      // console.log('start typing')
      if (!this.isTyping) {
        this.isTyping = true
        this.stopTimerTransfert()
        var agentSocketID = this.WATCHEEBOX_STATE.mySocketID
        // Demmarage du istyping
        _watcheebox.startIsTyping({
          // 'socket': this.$socket,
          agentSocketID: agentSocketID,
          datasAgent: this.user,
          datasVisiteur: this.datasVisiteur,
          message: this.msg,
          messageType: 1,
          agentName: unescape(this.fullName)
        })
      }
    },
    // affiche les infos visiteur
    afficheInfosVisiteur () {
      this.$emit('afficheInfosVisiteur')
    },

    // ----------------------------------------------------------------------------
    // Stop le istyping
    // ----------------------------------------------------------------------------
    stopTyping () {
      console.log('stop typing')
      this.isTyping = false
      // start le timer transfert si le temps d'attente est superieur à 0
      if (this.user.usr_time_transfert !== '0') {
        this.startTimerTransfert({'mounted': false})
      }
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID
      // Stop le istyping
      _watcheebox.stopIsTyping({
        // 'socket': this.$socket,
        agentSocketID: agentSocketID,
        datasAgent: this.user,
        datasVisiteur: this.datasVisiteur,
        message: this.msg,
        messageType: 1,
        agentName: unescape(this.fullName)
      })
    },
    /**
     * Gère l'envoi soit de pièce jointe soit d'un message chat
     */
    handleSend () {
      this.dragEnter
        ? this.uploadFiles()
        : this.sendMessage({ message: this.msgInput })
    },
    // ----------------------------------------------------------------------------
    // envois message en cliquant sur l'icone
    // ----------------------------------------------------------------------------
    clickSendMessage () {
      let msgToSend = this.msgInput
      if (msgToSend.indexOf('\n') !== -1) {
        msgToSend = msgToSend.replaceAll('\n', '<br>')
      }
      console.log('this.msgInput : ', msgToSend)
      this.dragEnter ? this.uploadFiles({ message: msgToSend }) : this.sendMessage({ message: msgToSend })
    },
    /**
     * Envoi un message (contenu dans data.message)
     */
    sendMessage (data) {
      console.log('sendMessage', data)
      // creation d'un timer pour checker l'inactivitée avant la cloture automatique
      // start le timer transfert
      if (this.user.usr_time_transfert !== '0') {
        this.startTimerTransfert({'mounted': false})
      }

      // l'agent offline ne peut envoyer de message sauf quand il est sur la page des messages en attentes
      if (this.$store.state._StoreWatcheeBox.status === 'offline') {
        if (this.$route.fullPath !== '/trafic/attente' && this.$route.fullPath !== '/trafic/contact' && !this.directChat) {
          console.log('pas possible', this.$route.name)
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('currentlyOffline'),
            context: 'error'
          })
          return
        }
      }
      if (data.message.length === 0 && data.attachments) {
        data.message = ''
      }

      if (
        data.message.trim().length !== 0 ||
        (data.message.length === 0 && data.attachments)
      ) {
        // si il y a un message
        // Si c'est un message pour facebook
        if (
          this.datasVisiteur.network &&
          this.datasVisiteur.network === 'facebook'
        ) {
          _watcheebox.envoisFacebook({
            // 'socket': this.$socket,
            datasAgent: this.user,
            datasVisiteur: this.datasVisiteur,
            message: data.message,
            attachments: data.attachments,
            messageType: 1,
            agentName: unescape(this.fullName)
          })
          // Si c'est un message pour whatsapp
        } else if (
          this.datasVisiteur.network &&
          this.datasVisiteur.network === 'whatsapp'
        ) {
          _watcheebox.envoisWhatsapp({
            // 'socket': this.$socket,
            datasAgent: this.user,
            datasVisiteur: this.datasVisiteur,
            message: data.message,
            attachments: data.attachments,
            messageType: 1,
            agentName: unescape(this.fullName)
          })
          // Sinon c'est un message pour MOON
        } else {
          var agentSocketID = this.WATCHEEBOX_STATE.mySocketID
          // Connexion de l'agent
          _watcheebox.envoisMessage({
            // 'socket': this.$socket,
            agentSocketID: agentSocketID,
            datasAgent: this.user,
            datasVisiteur: this.datasVisiteur,
            message: data.message,
            attachments: data.attachments,
            messageType: 1,
            agentName: unescape(this.fullName)
          })
          let dataToPost = new window.FormData()
          dataToPost.append('sessionId', this.datasVisiteur.visiteurID)
          dataToPost.append('agentid', this.user.id)
          if (this.doOnce !== this.datasVisiteur.visiteurID) {
            this.axios
              .post('post/visitor_contacted.php', dataToPost, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
              })
              .then(response => {
                this.doOnce = this.datasVisiteur.visiteurID
              })
              .catch()
          }
        }

        // -------------------------------------------------------------------------
        // ecrit le message directement dans l'historique de chat des datasVisiteur
        // -------------------------------------------------------------------------
        var statusMessage = 'read' // message lu
        // si c'est un message pour facebook
        if (
          this.datasVisiteur.network &&
          this.datasVisiteur.network === 'facebook'
        ) {
          statusMessage = 'delivery' // message envoyé mais non lu
        // si c'est un message pour whatsapp
        } else if (
          this.datasVisiteur.network &&
          this.datasVisiteur.network === 'whatsapp'
        ) {
          statusMessage = 'delivery' // message envoyé mais non lu
        } else {
          if (this.datasVisiteur.socketID === 0) {
            statusMessage = 'delivery' // message lu
          }
        }
        var dateMessage = Math.round(Date.now() / 1000) // timestamp mais en seconde
        var newMessage = {
          auteur: 'Agent',
          message: data.message,
          attachments: data.attachments,
          nameAuteur: this.user.fname + ' ' + this.user.lname,
          timestamp: dateMessage,
          type: '1',
          agentId: this.user.id,
          visitorId: this.datasVisiteur.visiteurID,
          status: statusMessage
        }
        // vide le champ text message
        this.$emit('update:msg', '')
        // masque leventuel menu des phrases pre-enregistrees et proposition de reponse AI
        this.showFilteredSentences = false
        // uniquement si dans la section attente
        // car generalement les visiteurs de cette section sont offline
        if (this.$route.fullPath === '/trafic/attente' || this.directChat) {
          // c'est une reponse d'un message en attente de l'agent
          // il faut alors les affacer de la liste des messages en attente
          // console.log('this.datasVisiteur', this.datasVisiteur)
          // console.log('data.message', data.message)
          this.AttenteReponseAgent(this.datasVisiteur, data.message)
          // il faut mettre à jour le store mais celui pour le visiteur offline
          // c'est pas le meme tableau que pou le visiteur online
          var cloneDataVisiteurOpened = _.cloneDeep(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.histoChat)
          cloneDataVisiteurOpened.push(newMessage) // injection du nouveau message agent dans le chat
          console.log('cloneDataVisiteurOpened', cloneDataVisiteurOpened)
          // pour mettre à jour l'histochat
          this.SET_VISITEURS_OPENED_HISTOCHAT(cloneDataVisiteurOpened)
          let cloneDataVisiteur = _.cloneDeep(this.datasVisiteur)
          cloneDataVisiteur.histoChat.push(newMessage) // injection du nouveau message agent dans le chat
          cloneDataVisiteur.lastMessage = '' // efface le lastMessage visiteur car il est lu par l'agent
          cloneDataVisiteur.chatted = true // efface le lastMessage visiteur car il est lu par l'agent
          this.$emit('sendReponseAttente', cloneDataVisiteur) // emit au niveau superieur
        } else if (this.$route.fullPath === '/trafic/contact') {
          // c'est un message envoyé à un contact
          // mise à jour de l'historique de chat du contact
          var cloneContactOpened = _.cloneDeep(this.$store.state._StoreWatcheeBox.contactOpened.histoChat)
          cloneContactOpened.push(newMessage) // injection du nouveau message agent dans le chat
          // console.log('this.datasVisiteur', this.datasVisiteur)
          // pour mettre à jour l'histochat
          this.SET_CONTACT_OPENED_HISTOCHAT(cloneContactOpened)
          let cloneDataVisiteur = _.cloneDeep(this.datasVisiteur)
          cloneDataVisiteur.histoChat.push(newMessage) // injection du nouveau message agent dans le chat
          cloneDataVisiteur.lastMessage = '' // efface le lastMessage visiteur car il est lu par l'agent
          cloneDataVisiteur.chatted = true // efface le lastMessage visiteur car il est lu par l'agent
          this.$emit('sendReponseAttente', cloneDataVisiteur) // emit au niveau superieur
        } else {
          // direct dans le store
          let cloneDataVisiteur = _.cloneDeep(this.datasVisiteur)
          cloneDataVisiteur.histoChat.push(newMessage) // injection du nouveau message agent dans le chat
          cloneDataVisiteur.lastMessage = '' // efface le lastMessage visiteur car il est lu par l'agent
          cloneDataVisiteur.chatted = true // efface le lastMessage visiteur car il est lu par l'agent
          this.SET_VISITEURS(cloneDataVisiteur)
        }
      }
      // il faut reduire tous les champs à leur hauteur minimum apres l'envois du message
      // id = tf_txtareaChat
      let els = document.querySelectorAll('#tf_txtareaChat')
      _.forEach(els, (txtArea, key) => {
        txtArea.style.height = '51px'
      })
      // document.getElementById('tf_txtareaChat').style.height = '51px'
      // le message est partie, on vide le textarea
      this.msgInput = ''
    },

    // ----------------------------------------------------------------------------
    // Indique si c'est la réponse d'un message en attente
    // ----------------------------------------------------------------------------
    AttenteReponseAgent (data, message) {
      // console.log('AttenteReponseAgent', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened)
      let dataToPost = new window.FormData()
      dataToPost.append('agentId', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.agentIdSelected)
      dataToPost.append('visiteurId', data.visiteurID)
      dataToPost.append('visiteurEmail', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.email)
      dataToPost.append('visiteurTel', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.tel)
      dataToPost.append('visiteurPageFocus', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.focus)
      dataToPost.append('entName', this.$store.state._User.entName)
      dataToPost.append('message', message)
      dataToPost.append('conseillerName', this.$store.state._User.fname + ' ' + this.$store.state._User.lname)
      // utilise la fiche visiteur pour recuperer le contact
      // afin de lui envoyer par notif la réponse du conseiller
      // console.log('message attente lu : ', dataToPost)
      // mise à jour de la base de donnée
      this.axios
        .post('post/allMessageVisiteurAttenteLu.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          if (response.statusText === 'OK') {
            // si je suis un simple conseiller
            // console.log('modification dans colleagues[]')
            // recherche pour quel agent j'ai répondu
            let idAgentChatOpened = this.$store.state._StoreWatcheeBox.idAgentSelectedListe
            console.log('idAgentChatOpened', idAgentChatOpened)
            // recupère l'index du message supprimé
            let index = _.findIndex(this.$store.state._User.colleagues, function (o) { return Number.parseInt(o.USR_ID) === Number.parseInt(idAgentChatOpened) })
            // console.log('index', index)
            if (index !== -1) {
              // console.log('il y a une liste de message :', idAgentChatOpened)
              if (this.$store.state._User.colleagues[index].listeMessages.length) {
                // clone le tableau avant de travailler dessus
                let messagesList = _.cloneDeep(this.$store.state._User.colleagues[index].listeMessages)
                // console.log('messagesList', messagesList)
                // retire les message corespondant au visiteur qui a eu sa reponse
                let newListe = _.remove(messagesList, function (o) { return o.visiteurID !== data.visiteurID })
                // mise à jour de user.listeMessages
                this.SET_DEL_MESSAGE_ATTENTE({
                  'liste': newListe,
                  'agentId': idAgentChatOpened
                })
              } else {
                // console.log('pas de liste pour :', idAgentChatOpened)
              }
            }
            // ouvre la dialogueBox pour indique la fermeture de la convesation
            this.dialogCloseChat = true
          }
        })
        .catch()
    },

    // ----------------------------------------------------------------------------
    // reduit la fenetre de chat pour voir ce qu'il y a derrière
    // en changeant la class (bigChat/smallChat) de la fenetre de chat
    // ----------------------------------------------------------------------------
    toggleChat () {
      if (this.overMenu) return
      this.opened = !this.opened
      if (this.opened) {
        this.$emit('bigChat')
      } else {
        this.$emit('smallChat')
      }
    },

    // ----------------------------------------------------------------------------
    // agrandi en full width la fenetre de chat
    // en changeant la class (bigChat/smallChat) de la fenetre de chat
    // ----------------------------------------------------------------------------
    toggleBigChat () {
      // console.log('this.fullWidth', this.fullWidth)
      this.fullWidth = !this.fullWidth
      if (this.fullWidth) {
        this.$emit('bigWidthChat')
      } else {
        this.$emit('smallWidthChat')
      }
    },

    fermeDialogCloseChat (data) {
      console.log('fermeDialogCloseChat', data)
      this.dialogCloseChat = data.dialogCloseChat
      // this.stopListenerDropZone() // efface le timer dropzone
      // si il y a deja des infos de visioconf en cours
      if (this.$store.state._User.sessionVisioconf.confURL) {
        if (this.$store.state._User.sessionVisioconf.visiteur.visiteurID === this.datasVisiteur.visiteurID) {
          // on efface du store les infos
          // this.DEL_SESSION_VISIOCONF()
          this.$store.commit('_StoreWatcheeBox/DEL_SESSION_VISIOCONF')
          this.$store.commit('_StoreWatcheeBox/DEL_SESSION_VISIOVENTE')
        }
      }
    },

    // ----------------------------------------------------------------------------
    // ouvre la dialogBox 'fermeChat' sur le btn dans la div de deconnexion .offlineVisiteur
    // quant le visiteur n'est plus la
    // ----------------------------------------------------------------------------
    fermeChat () {
      // console.log('ferme chat', this.$route.fullPath)
      // console.log('route.name', this.$route.name)
      if (this.$route.fullPath === '/trafic/monitoring') {
        this.$emit('chatSessionSelect', 0)
      } else {
        if (this.$route.name !== 'attente' && this.$route.name !== 'contact' && !this.directChat) {
          // console.log('visiteur ou chatting')
          // met à jour les switch en regardant les cookies
          // this.settingsFromCookies()
          // stop le timer d'attente uniquement sur le temps est superieur à zero
          if (this.user.usr_time_transfert !== '0') {
            this.stopTimerTransfert() // stop le timer transfert
          }
          // ouvre la dialogBox
          this.dialogCloseChat = true
        } else {
          // console.log('ferme juste le chat sans dialogbox')
          this.ACTION_CLOSE_MESSAGING({
            datasVisiteur: this.datasVisiteur,
            fullPath: this.$route.fullPath
          })
          // ferme directement la fenetre
          // fermeDialogCloseChat
          // this.dialogCloseChat = true
        }
      }
    },

    // ----------------------------------------------------------------------------
    // Actions de transfere de chat vers un autre agent dispo
    // ----------------------------------------------------------------------------
    transferChat () {
      // si un agent est selectionné dans la liste
      if (this.selectedAgent.id !== '') {
        // il faut recuperer toutes les données visiteur pour le transfere
        var datasVisiteurSelect = {
          socketID: this.datasVisiteur.socketID,
          visiteurID: this.datasVisiteur.visiteurID,
          visiteurKey: this.datasVisiteur.roomName,
          siteID: this.datasVisiteur.siteID
        }
        var mySocketID = this.WATCHEEBOX_STATE.mySocketID
        _watcheebox.SendTransfertVisitor({
          selectedAgent: this.selectedAgent,
          datasSelectedVisiteur: datasVisiteurSelect,
          agentsArray: this.agentsArray,
          // 'socket': this.$socket,
          myAgentID: this.$store.state._User.id,
          mySocketID: mySocketID,
          agentSenderName: this.fullName,
          automatique: true
        })
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('selectAgentList'),
          context: 'warning'
        })
      }
    },

    // ----------------------------------------------------------------------------
    // Check la dispo d'agent avant transfere
    // il faudrait la passer dans le store cette fonction
    // ----------------------------------------------------------------------------
    checkDispoAGent () {
      // console.log('check dispo agent')
      // this.$store.commit('_StoreWatcheeBox/CHECK_DISPO_AGENT', {
      //   datasVisiteur: this.datasVisiteur
      // })

      // visiblemet il n'y a plus d'activité sur ce chat
      this.chatActivity = false
      // si conversation un juste chat entrant
      let sendFormeSatis = false
      let sendClotureChat = false
      // c'est une conversation (l'agent a repondu au moins 1 message),
      // on regarde dans les cookies si il faut le formulaire et la cloture de chat
      // sinon on ferme uniquement le chat sans formulaire ni cloture
      if (this.datasVisiteur.chatted) {
        sendFormeSatis = this.$cookie.get('wz-satisfaction-survey') === 'true' || false
        sendClotureChat = this.$cookie.get('wz-closing-chat') === 'true' || false // on ferme
      }
      // console.log('this.$store.state._StoreWatcheeBox.transfertStatusEmission.status', this.$store.state._StoreWatcheeBox.transfertStatusEmission.status)
      // console.log('this.visitorLeft', this.visitorLeft)
      // console.log('this.datasVisiteur.chatted', this.datasVisiteur.chatted)

      // check pour transfert uniquement :
      // - si pas en attente de reponse de transfert de chat
      // - si visiteur est encore en ligne
      // - si l'agent n'a pas encore ecrit au visiteur
      if (
        // c'est utils cette premiere condition je pense
        this.$store.state._StoreWatcheeBox.transfertStatusEmission.status !== 'wait' &&
        this.visitorLeft === 'no' &&
        !this.datasVisiteur.chatted
        ) {
        let transfereStatus = false
        // parcour le tableau computé des agents autorisé pour ce site
        _.forEach(this.listeAgentsAutorized, (agent, key) => {
          // pour tous les autres agent sauf moi
          if (agent[8] !== this.user.id) {
            // let agentChecked = _.findIndex(this.agentsChecked, agent[2])
            let agentChecked = this.agentsChecked.findIndex(agentCheck => agentCheck === agent[2])
            // console.log('agentChecked', agentChecked)
            // et si l'agent est dispo
            if (agent[3] === 'online' && agentChecked === -1) {
              // enregistre l'id de l'agent dans tableau pour ne pas lui transferer automatiquement
              // ce visiteur au prochain check agent dans le cas ou l'agent refuse le transfert
              this.agentsChecked.push(agent[2])
              transfereStatus = true
              console.log('transfere dispo avec cet agent :', agent[1])
              // agent selectionné
              this.selectedAgent = {
                id: agent[2],
                name: agent[1],
                status: agent[3]
              }
              // on transfere vers cet agent
              this.transferChat()
              return false
            }
          }
        })
        // si pas d'agent dispo
        if (!transfereStatus) {
          // on cloture le chat car impossible de la transferer
          // console.log('Aucun agent dispo')
          this.autoFermetureChat({
            datasVisiteur: this.datasVisiteur,
            formulaireSatisfaction: sendFormeSatis, // satisfaction si cookie true
            clotureChat: sendClotureChat, // on ferme si cookies true
            // message: 'Aucuns conseillés disponibles pour vous répondre'
            message: ''
          })
          // on relance le timer pour retester plus tard
          // this.startTimerTransfert({'mounted': false})
        }
      // si encore en ettente de reponse de transfert
      } else {
        // on cloture le chat car impossible de la transferer
        // console.log('transfert "wait" ou visiteur offline')
        this.autoFermetureChat({
          datasVisiteur: this.datasVisiteur,
          formulaireSatisfaction: sendFormeSatis, // satisfaction si cookie true
          clotureChat: sendClotureChat, // on ferme si cookie true
          // message: 'Aucuns conseillés disponibles pour vous répondre'
          message: ''
        })
      }
    },

    // ----------------------------------------------------------------------------
    // ferme le chat
    // avec option envois formulaire de satisfaction
    // et cloture de chat
    // c'est un message de type 4
    // ----------------------------------------------------------------------------
    autoFermetureChat (data) {
      console.log('fermeture du chat')
      this.ACTION_CLOSE_CHAT({
        formulaireSatisfaction: data.formulaireSatisfaction,
        datasVisiteur: data.datasVisiteur,
        clotureChat: data.clotureChat,
        message: data.message,
        fullPath: this.$route.fullPath
      })
    },

    // ----------------------------------------------------------------------------
    // Actions du menu deroulant de droite de la fenetre de chat
    // en changeant la class (bigChat/smallChat) de afenetre de chat
    // ----------------------------------------------------------------------------
    menuAction (value, idVisiteur) {
      if (value === 'transferer') {
        // transfere ce chat vers un autre agent
        this.selectedVisiteur = idVisiteur // id du visiteur selectionné
        this.dialogTransfereChat = true // affiche la dialogueBox
        this.selectedAgent = { id: '', name: '', status: '' }
        // remise à zero du status de transfere
        // this.$store.commit('_StoreWatcheeBox/SET_TRANSFERE_STATUS', '')
        this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
          status: '',
          emission: true,
          messageDatas: ''
        })
      } else if (value === 'bannChat') {
        this.dialogBannChat = true
      }
    },

    showUnreadMessages () {
      this.stopScrollAuto = false
      this.remonteChat()
    },

    // ecoute la dropzone
    startListenerDropZone () {
      this.$el.children[1].children[0].children[0].addEventListener(
        'dragenter',
        event => {
          if (!this.dragChatStatus) {
            // marche uniquement si c'est pas un chat qui est drag
            this.dragEnter = true
          }
        }
      )
    },

    // ------------------------------------------
    // arrete l'ecoute la dropzone
    // ------------------------------------------
    stopListenerDropZone () {
      this.$el.children[1].children[0].children[0].removeEventListener(
        'dragenter',
        event => {}
      )
    },

    // ------------------------------------------
    // demarre le timer d'inactivité de l'agent
    // ------------------------------------------
    stopTimerTransfert () {
      // clearTimeout(this.myTimer)
      // on stop le timer activité de l'agent
      this.SET_STATUS_TIMERINACTIFAGENT({
        placePupitre: this.datasVisiteur.placePupitre,
        timerAgent: false
      })
      // visiblemet l'agent est a nouveau actif sur ce chat
      this.chatActivity = true
    },

    // ------------------------------------------
    // demarre le timer d'inactivité de l'agent
    // ------------------------------------------
    startTimerTransfert (data) {
      // console.log('startTimerTransfert', data)
      this.stopTimerTransfert() // efface le timer existant
      let myTimer = setTimeout(
        () => {
          this.checkDispoAGent()
        },
        this.timeTimer
        // 10000
      )
      // on lance le timer d'inacvtivité de l'agent
      this.SET_STATUS_TIMERINACTIFAGENT({
        placePupitre: this.datasVisiteur.placePupitre,
        timerAgent: myTimer,
        mounted: data.mounted
      })
    },

    copyMessage (content) {
      const textArea = document.createElement('textarea')
      textArea.value = content
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        document.execCommand('copy')
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('copied'),
          context: 'success'
        })
      } catch (err) {
      }

      document.body.removeChild(textArea)
    },

    // ---------------------------------------------
    // pour tester si autorisé à afficher
    // ---------------------------------------------
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    },
    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      let brides = this.$store.state._User.brides
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '1') {
            return true
          } else {
            return false
          }
        }
      }
    }
  },

  watch: {
    // ----------------------------------------------------------------------------
    // pour fermer la dialogBox
    // ----------------------------------------------------------------------------
    'datasVisiteur.visiteurID': function () {
      this.dialogTransfereChat = false
    },

    'dataWatchVisteur.visiteurID': function () {
      if (this.focusPupitre.focusSessionID === this.datasVisiteur.visiteurID) {
        this.$refs.inputChat.focus()
      }
    },

    // ----------------------------------------------------------------------------
    // quand l'agent inverse les flux vidéos
    // ----------------------------------------------------------------------------
    'WATCHEEBOX_STATE.sessionVisioVente.toggleStream': function (val) {
      if (val) {
        this.zoomStream = true
      } else {
        this.zoomStream = false
      }
    },

    // nombre de visiteur qui regarde la visiovente
    // infos sur la visioVente en cours
    'WATCHEEBOX_STATE.sessionVisioVente.numContacts': function (e) {
      console.log('WATCHEEBOX_STATE.sessionVisioVente.numContacts', e)
      this.numContacts = e
      // si il y a une visio en cours
      // return this.$store.state._StoreWatcheeBox.sessionVisioVente.numContacts
    },

    // Etat de la visiovente actif/inactif
    'WATCHEEBOX_STATE.sessionVisioVente.startConf': function (val) {
      console.log('WATCHEEBOX_STATE.sessionVisioVente.startConf', this.sessionVisioVente)
      // si on est sur la page visiteurs, on coupe direct la visioconf
      if (this.$route.fullPath === '/trafic/visitors') {
        if (this.sessionVisioVente.placePupitreVisio === 0) {
          if (val) {
            this.activeVisiovente = true
          } else {
            this.activeVisiovente = false
          }
        }
      } else {
        if (this.sessionVisioVente.placePupitreVisio === this.datasVisiteur.placePupitre) {
          if (val) {
            this.activeVisiovente = true
          } else {
            this.activeVisiovente = false
          }
        } else {
          this.activeVisiovente = false
        }
      }
    },

    // ----------------------------------------------------------------------------
    // quand un changement de status du transfert chat
    // ----------------------------------------------------------------------------
    'WATCHEEBOX_STATE.transfertStatusEmission.status': function (e) {
      if (e === 'wait') {
        console.log('transfert en attente :', e)
      } else if (e === 'no') {
        console.log('transfert refusé :', e)
        // si l'agent n'est plus actif sur le chat
        // et que le transfert auto est refusé
        if (!this.chatActivity) {
          // il faut rechecker si un autre agent est dispo pour ce chat
          // console.log('WATCHEEBOX_STATE.transfertStatusEmission.status', e)
          this.checkDispoAGent()
        }
      } else {
        console.log('transfert accepté :', e)
      }
    },

    // ----------------------------------------------------------------------------
    // quand un nouveau message arrive
    // et uniquement si le scroll automatique n'est plus activé
    // ----------------------------------------------------------------------------
    'dataWatchVisteur.histoChat': function () {
      if (this.dataWatchVisteur.histoChat) {
        var lengthChat = this.dataWatchVisteur.histoChat.length
        if (lengthChat) {
          // si c'est un message non lu et pas un istyping
          if (
            !this.dataWatchVisteur.histoChat[lengthChat - 1].lu &&
            !this.dataWatchVisteur.histoChat[lengthChat - 1].isTyping &&
            this.dataWatchVisteur.histoChat[lengthChat - 1].auteur !== 'Agent'
          ) {
            this.startTimerExpand() // lance le timer extention chat pour la visio uniquement
            // si le scroll chat est bien en bas au max
            if (!this.stopScrollAuto) {
              // marque dans l'histoChat que le message est lu par l'agent
              this.$store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_LU', {
                timestamp: this.dataWatchVisteur.histoChat[lengthChat - 1]
                  .timestamp,
                visitorId: this.dataWatchVisteur.histoChat[lengthChat - 1]
                  .visitorId
              })
              // sinon il est plus au dans le chat (pour lire de vieux messages)
            } else {
              // si le marqueur de message non lu n'est pas encore activé
              if (!this.marqueurChat) {
                this.marqueurChat = true
                // insertion du marqueur de message non lu dans l'histoChat
                this.$store.commit('_StoreWatcheeBox/SOCKET_MAKE_CHAT_NON_LU', {
                  timestamp: this.dataWatchVisteur.histoChat[lengthChat - 1]
                    .timestamp,
                  visitorId: this.dataWatchVisteur.histoChat[lengthChat - 1]
                    .visitorId
                })
              }
            }
            // this.showProposedSentences = true
          }
          // this.aiResponses = []
          this.showSentences = false
        }
      }
    },

    // ----------------------------------------------------------------------------
    // mise a jours du status des message quand le visiteur se reconnect
    // ----------------------------------------------------------------------------
    'dataWatchVisteur.socketID': function (v) {
      if (v) {
        this.visitorLeft = 'no'
        // marque toutes les bulles de chat non lu comme lu
        _.forEach(this.dataWatchVisteur.histoChat, (chat, key) => {
          if (chat.status === 'delivery') {
            // marque dans l'histoChat tous les messages agent sont lu par le visiteur
            this.$store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_DELIVRE', {
              timestamp: chat.timestamp,
              visitorId: chat.visitorId
            })
          }
        })
      } else {
        // ne s'applique pas au visiteur facebook
        if (this.dataWatchVisteur.network === 'facebook' || this.dataWatchVisteur.network === 'whatsapp') {
          this.visitorLeft = 'no'
        } else {
          // quand il se deconnect on efface les isTyping qui reste affiché dans le chat
          this.$store.commit('_StoreWatcheeBox/SOCKET_REMOVE_TYPING', {
            chatSession: this.dataWatchVisteur.visiteurID
          })
          if (this.visitorLeft !== 'yes') {
            this.visitorLeft = 'maybe'
          }
          // lance le timer pour savoir si le visiteur est vraiment parti
          setTimeout(() => {
            if (!this.dataWatchVisteur.socketID) {
              this.visitorLeft = 'yes'
            }
          }, 10000)
        }
      }
    },

    // ----------------------------------------------------------------------------
    // garde des infos sur le visiteur même si il est deconnecté
    // ----------------------------------------------------------------------------
    datasVisiteur: function (val, oldval) {
      if (!val) {
        this.dataWatchVisteur = oldval
      } else {
        this.dataWatchVisteur = val
      }
    },

    // ----------------------------------------------------------------------------
    // Quant un visiteur facebook a lu le message
    // ----------------------------------------------------------------------------
    'WATCHEEBOX_STATE.statusMessage': function (val, oldval) {
      if (val.senderID === this.dataWatchVisteur.visiteurID) {
        // Mon visiteur vient de lire les messages
        _.forEach(this.dataWatchVisteur.histoChat, (chat, key) => {
          if (chat.status && chat.status === 'delivery') {
            chat.status = 'read'
          }
        })
      }
    },

    formulaireSatisfaction (v) {
      this.$cookie.set('wz-satisfaction-survey', v, { expires: '1Y' })
    },

    clotureChat (v) {
      this.$cookie.set('wz-closing-chat', v, { expires: '1Y' })
    },

    msg (v) {
      this.msgInput = v
      // Focus sur la zone de saisie
      this.$refs.inputChat.focus()
    },

    // -----------------------------------------------------------
    // filtre les phrases enregistrées en fonction de la saisie : declenche pour chaque lettre tapee au clavier
    // -----------------------------------------------------------
    msgInput (v) {
      // console.log('msgInput : ', v)
      if (v || v.length) {
        // this.showProposedSentences = false
        if (v.length > 2 && v.length < 16) {
          // s'affiche uniquement si autorisé
          if (this.brideMenu('media_phrases') === '1' && this.brideMenu('media_phrases_completion') === '1') {
            this.showFilteredSentences = true
          }
        } else {
          this.showFilteredSentences = false
        }
      }
    }
  },

  /**
   * A la mise à jour du rendu du composant
   * scroll tout en bas de l'historique du chat
   */
  updated () {
    this.$nextTick(() => {
      if (!this.stopScrollAuto) {
        this.remonteChat()
      }
    })
  },
  mounted () {
    if (this.sessionVisioVente.placePupitreVisio === 0 && this.$route.name === 'visitors') {
      if (this.sessionVisioVente.startConf) {
        this.activeVisiovente = true
      } else {
        this.activeVisiovente = false
      }
    } else {
      if (this.sessionVisioVente.placePupitreVisio === this.datasVisiteur.placePupitre) {
        if (this.sessionVisioVente.visiteurID === this.datasVisiteur.visiteurID) {
          if (this.sessionVisioVente.startConf) {
            this.activeVisiovente = true
          } else {
            this.activeVisiovente = false
          }
        } else {
          this.activeVisiovente = false
        }
      }
    }
    // uniquement si le temps d'attente est superieur à 0
    if (this.user.usr_time_transfert && this.user.usr_time_transfert !== '0') {
      this.timeTimer = ((this.user.usr_time_transfert * 60) * 1000)
    }
    // au chargement on recupere le 'datavisiteur'
    // car le 'dataWatchVisiteur' est vide, pas encore passé dans le watch
    this.dataWatchVisteur = this.datasVisiteur
    if (this.dataWatchVisteur.network === 'facebook' || this.dataWatchVisteur.network === 'whatsapp') {
      this.visitorLeft = 'no'
    }
    // console.log('myTimer', this.myTimer)
    // console.log('this.user.usr_time_transfert', this.user.usr_time_transfert)
    // start le timer transfert si le temps d'attente est superieur à 0
    if (this.user.usr_time_transfert !== '0') {
      this.startTimerTransfert({'mounted': true})
    }

    if (this.$store.state._User.entKey === '9c44184c124fda32ac19523ff93d2488') {
      this.checkForMotif = true
    }
    // ----------------------------------------------------------------------------
    // Drag un fichier dans la page
    // ----------------------------------------------------------------------------
    // this.startListenerDropZone()

    // this.settingsFromCookies()
    this.id_conversation = 'conversation_' + this.datasVisiteur.visiteurID

    // création d'un tableau avec uniquement les agents
    // autorisés à communiqueer avec le site du visiteur en chat
    // pour eviter de transferer cette conversation à un agent non autoriser
  },

  beforeDestroy () {
    // this.stopListenerDropZone() // efface le timer dropzone
    this.stopTimerTransfert() // efface le timer existant
    // this.$el.removeEventListener('dragenter', event => {})
  },

  computed: {
    ...mapState('_StoreWatcheeBox', [
      'agentsArray',
      'transfertStatusEmission',
      'focusPupitre',
      'visiteurChatSelected',
      'messageAttenteSelected',
      'contactSelected',
      'listeAllVisiteurs',
      'status',
      'isConnected',
      'dragChat',
      'sessionVisioVente'
    ]),
    ...mapState('_Sites', ['sites', 'siteSelected']),
    ...mapState('_User', ['brides', 'entLevel']),
    ...mapGetters('_User', ['user', 'fullName', 'account']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapGetters('_Sites', ['AUTORIZED_AGENTS', 'GET_SITE_BY_KEY']),
    // retourne la liste des agent autorisés à chater sur ce site
    listeAgentsAutorized () {
      // on filtre les agents
      return this.AUTORIZED_AGENTS({
        agentsArray: this.agentsArray,
        siteID: this.datasVisiteur.siteID,
        myID: this.user.id
      })
    },
    // infos sur la visio en cours
    dataVisio () {
      // si il y a une visio en cours
      if (this.$store.state._StoreWatcheeBox.sessionVisioconf.confURL) {
        // si c'est bien avec ce visiteur
        if (this.$store.state._StoreWatcheeBox.sessionVisioconf.visiteur.visiteurID === this.datasVisiteur.visiteurID) {
          // console.log('bien en conf avec ce visteur', this.$store.state._User.sessionVisioconf.visiteur.visiteurID)
          return this.$store.state._StoreWatcheeBox.sessionVisioconf
        }
      } else {
        return {confURL: false}
      }
    },
    // infos sur la visioVente en cours
    dataVisioVente () {
      // console.log('datavisiovente : this.datasVisiteur.visiteurID', this.datasVisiteur.visiteurID)
      // console.log('datavisiovente : this.sessionVisioVente', this.sessionVisioVente)
      // si il y a une visio en cours
      if (this.sessionVisioVente.sessionId) {
        // si c'est bien avec ce visiteur
        if (this.sessionVisioVente.visiteurID === this.datasVisiteur.visiteurID) {
          // console.log('bien en conf avec ce visteur', this.sessionVisioVente.visiteurID)
          return this.sessionVisioVente
        } else {
          // console.log('pas en conf avec ce visteur', this.sessionVisioVente.visiteurID)
          return {
            confName: false
          }
        }
      } else {
        return {
          sessionId: null
        }
      }
    },
    // etat du micro
    muteMic () {
      return this.sessionVisioVente.muteMic
    },
    textMuteMic () {
      if (this.sessionVisioVente.muteMic) {
        return this.$t('Activer le micro')
      } else {
        return this.$t('Couper le micro')
      }
    },
    // stream inversés
    toggleVideoStream () {
      // return TouchList.sessionVisioVente.toggleStream
      return this.sessionVisioVente.toggleStream
    },
    // etat de la caméra
    muteCam () {
      return this.sessionVisioVente.muteCam
    },
    textMuteCam () {
      if (this.sessionVisioVente.muteCam) {
        return this.$t('Activer la caméra')
      } else {
        return this.$t('Couper la caméra')
      }
    },
    checkSessionWhatsapp () {
      let jour = 86400000
      // si la date du message est de moins de 24 heures on est encore dans la session whatsapp
      if ((this.messageAttenteSelected + jour) > Date.now()) {
        return 1
      } else {
        return 0
      }
    },
    // les droits de l'agent
    userRights () {
      console.log('this.account.rights', this.account.rights)
      return this.account.rights
    },
    placeholder () {
      // console.log('multisite_indicateur :', this.brideMenu('multisite_indicateur'))
      let url = String(this.datasVisiteur.pagesFocus)
      if (this.brideMenu('multisite_indicateur') === '1') {
        // console.log('bride 1')
        return String(_.upperFirst(this.$t('forTheSite')) + ' ' + extractDomain(url) + '\n' + this.$t('typeYourMessage'))
      } else {
        // console.log('bride 0')
        return String(this.$t('typeYourMessage'))
      }
      // return domain_from_url(this.datasVisiteur.pagesFocus)
    },

    // retourn la bonne date
    dateHeure () {
      if (!this.dataWatchVisteur || !this.dataWatchVisteur.histoChat) return []
      return this.dataWatchVisteur.histoChat.map(function (item) {
        let itemTimestamp =
          item.timestamp && item.timestamp.toString().length === 10
            ? item.timestamp * 1000
            : item.timestamp
        let m = moment(itemTimestamp)
        return m.format('LTS')
      })
    },

    nameAuteur () {
      if (!this.dataWatchVisteur || !this.dataWatchVisteur.histoChat) return []
      return this.dataWatchVisteur.histoChat.map(function (item) {
        return item.nameAuteur !== 'undefined'
      })
    },

    // nombre de message visiteur non lu par l'agent
    checkLastMessage () {
      if (this.dataWatchVisteur && this.dataWatchVisteur.lastMessage !== '') {
        return true
      } else {
        return false
      }
    },

    // nombre de message visiteur non lu par l'agent
    nbMessageNonLu () {
      let nbMessageNonLu = 0
      let lengthChat = this.dataWatchVisteur.histoChat
        ? this.dataWatchVisteur.histoChat.length
        : 0
      let indexMarqueur = _.findIndex(this.dataWatchVisteur.histoChat, {
        marqueurMessageNonLu: true
      })
      if (indexMarqueur === -1) return
      for (let i = indexMarqueur; i < lengthChat; ++i) {
        if (
          this.dataWatchVisteur.histoChat[i].auteur !== 'Agent' &&
          !this.dataWatchVisteur.histoChat[i].lu &&
          !this.dataWatchVisteur.histoChat[i].isTyping &&
          !this.dataWatchVisteur.histoChat[i].marqueurMessageNonLu
        ) {
          nbMessageNonLu++
        }
      }
      return nbMessageNonLu
    },

    // affiche le nom du visiteur si dispo
    nameVisiteur () {
      let name = ''
      if (this.dataWatchVisteur.network === 'facebook') {
        if (this.$route.name === 'attente') {
          name = this.dataWatchVisteur.visiteurName
        } else if (this.$route.name === 'contact') {
          name = this.dataWatchVisteur.firstName + ' ' + this.dataWatchVisteur.lastName
        }
      } else if (this.dataWatchVisteur.network === 'whatsapp') {
        if (this.$route.name === 'attente') {
          name = this.dataWatchVisteur.visiteurName
        } else if (this.$route.name === 'contact') {
          name = this.dataWatchVisteur.profileName
        }
      } else {
        if (this.dataWatchVisteur.visiteurName) {
          name = this.dataWatchVisteur.visiteurName
        } else {
          name = this.dataWatchVisteur.visiteurID
        }
      }
      return name
    },

    // retourne si cobrowsing actif
    superIstypingStatusSite () {
      var siteVisiteurSelect = _.find(this.$store.state._Sites.sites, {
        LIC_KEY: this.dataWatchVisteur.roomName
      })
      var SuperIstyping = true
      if (siteVisiteurSelect.DSK_SUPERISTYPING === '0') {
        SuperIstyping = false
      }
      return SuperIstyping
    },

    returnFocusSessionId () {
      if (this.$route.name === 'visitors') {
        return this.visiteurChatSelected
      } else if (this.$route.name === 'attente' || this.$route.name === 'contact') {
        return this.messageAttenteSelected.visiteurID
      } else {
        return this.focusPupitre.focusSessionID
      }
    },
    /**
     * @return {Array} liste des phrases filtrées
     * et proposées à l'autocomplétion
     */
    filteredSentences () {
      if (this.showFilteredSentences) {
        // console.log('filteredSentences : ', this.msgInput)
        return this.$store.getters['_Biblios/GET_SENTENCES'](this.msgInput)
      } else {
        return false
      }
    },

    hasMotif () {
      let thisVisit = _.find(
        this.$store.state._StoreWatcheeBox.listeAllVisiteurs,
        {
          visiteurID: this.dataWatchVisteur.visiteurID
        }
      )
      return thisVisit ? thisVisit.motif : false
    },

    findUrls () {
      return this.datasVisiteur.histoChat.map(m => {
        let source = (m.message || '').toString()
        let urlArray = []
        let matchArray
        // Regular expression to find FTP, HTTP(S) and email URLs.
        // let regexToken = /([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.[a-zA-Z0-9]{1,4}\/?(.+)?/gm
        // let regexToken = /(((ftp|https?):\/\/)[-\w@:%_+.~#?,&=]+)|((mailto:)?[_.\w-]+@([\w][\w-]+\.)+[a-zA-Z]{2,3})/g
        let regexToken = /(((ftp|https?):\/\/)[-\w@:%_+.~#?,&=]+)?[-a-zA-Z@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&,/=]*)/g
        // Iterate through any URLs in the text.
        while ((matchArray = regexToken.exec(source)) !== null) {
          let token = matchArray[0]
          urlArray.push(token)
        }
        let newMessage = source
        if (newMessage.indexOf('pushProduct') === -1) newMessage = source.replace(urlArray, '<a href="' + urlArray + '" target="_blank">' + urlArray + '</a>')
        return newMessage
      })
    },

    // url du bon serveur (prod / dev)
    serveurAI () {
      if (window.location.origin.indexOf('localhost') > -1) {
        return 'https://lb-sw-ai-dev-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice-preprod') > -1) {
        return 'https://lb-sw-ai-preprod-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice') > -1) {
        return 'https://lb-sw-ai-prod.watcheebox.net/'
      } else {
        return 'https://lb-sw-ai-prod.watcheebox.net/'
      }
    }
  }
}
</script>
<style>
.v-toolbar__content {padding: 0 12px;}
.WatchBox-Toolbar-Icone {height: 22px;}
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzFenetreChat.vue